import React from 'react';
import BasicButton from './BasicButton';
import { primaryButton } from '@styles/app';

const PrimaryButton: React.FC<any> = (props): JSX.Element => {
  return <BasicButton {...props} variant={primaryButton} />;
};

export default PrimaryButton;
